interface SvgRightProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}
export default function SvgRight(props: SvgRightProps) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}><path d="M13.5 4.5L12.4275 5.54475L18.1125 11.25H3V12.75H18.1125L12.4275 18.4298L13.5 19.5L21 12L13.5 4.5Z" fill="currentColor" /></svg>;
}